import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const AdminDashboard = lazyWithRetry(
  () => import("./ui/pages/AdminDashboard"),
  "AdminDashboard",
);
const InspectorDashboard = lazyWithRetry(
  () => import("./ui/pages/InspectorDashboard"),
  "InspectorDashboard",
);
const SupervisorStatisticsDashboard = lazyWithRetry(
  () => import("./ui/pages/SupervisorStatisticsDashboard"),
  "SupervisorStatisticsDashboard",
);
const RHDashboard = lazyWithRetry(
  () => import("./ui/pages/RHDashboard"),
  "RHDashboard",
);
const GeneralDashboard = lazyWithRetry(
  () => import("./ui/pages/GeneralDashboard"),
  "GeneralDashboard",
);
const DeveloperDashboard = lazyWithRetry(
  () => import("./ui/pages/DeveloperDashboard"),
  "DeveloperDashboard",
);
const InstalacionDashboard = lazyWithRetry(
  () => import("./ui/pages/InstalacionDashboard"),
  "InstalacionDashboard",
);

export const SUPERVISOR_DASHBOARD_ALLOWED_ROLES = [3, 5];

/**
 * Rutas de dashboards por rol
 */
const dashboardRoutes = buildRoutes([
  // Admin Dashboard
  {
    path: "/homeadmin",
    element: AdminDashboard,
    roles: [1, 5],
  },
  {
    path: "/homeadmin/:widget",
    element: AdminDashboard,
    roles: [1, 5],
  },

  // Inspector Dashboard
  {
    path: "/homeinspector",
    element: InspectorDashboard,
    roles: [2, 5],
  },

  // Supervisor Dashboard
  {
    path: "/homesupervisor",
    element: SupervisorStatisticsDashboard,
    roles: SUPERVISOR_DASHBOARD_ALLOWED_ROLES,
  },

  // RH Dashboard
  {
    path: "/homerh",
    element: RHDashboard,
    roles: [7, 5],
  },
  {
    path: "/homerh/:widget",
    element: RHDashboard,
    roles: [7, 5],
  },

  // General Dashboard
  {
    path: "/homegeneral",
    element: GeneralDashboard,
    roles: [6, 5],
  },
  {
    path: "/homegeneral/:widget",
    element: GeneralDashboard,
    roles: [6, 5],
  },

  // Instalación Dashboard (misma funcionalidad que General, sin selector de usuario)
  {
    path: "/homeinstalacion",
    element: InstalacionDashboard,
    roles: [8, 5],
  },
  {
    path: "/homeinstalacion/:widget",
    element: InstalacionDashboard,
    roles: [8, 5],
  },

  // Developer Dashboard
  {
    path: "/developer-dashboard",
    element: DeveloperDashboard,
    roles: [5],
  },
]);

export default dashboardRoutes;
